// import the library
import { library } from "@fortawesome/fontawesome-svg-core";

// import your icons
import {
  faBars,
  faSearch,
  faShoppingCart,
  faStar,
} from "@fortawesome/free-solid-svg-icons";

library.add(faBars, faSearch, faShoppingCart, faStar);
